import { useGroupRules, UserGroupRules } from 'src/graphql/entities/group-rules';

export function useCanViewCustomAttributes(): boolean {
  const { groupRules } = useGroupRules();

  return Boolean(groupRules[UserGroupRules.AccessToViewCustomAttributes]);
}
